import React from "react";
import { assets } from "../../Assets/assets";
import PostRequirementSection from "../../Components/UserSideComponents/RequirementsPost/PostRequirementSection";
import { useSearchParams } from "react-router-dom";

const RequirementFill = () => {
  const [searchParams] = useSearchParams();
  const offerId = searchParams.get("offerId"); // null if not present

  return (
    <section className="w-full">
      <div
        className="w-full h-[140px] sm:h-[220px] md:h-[260px] lg:h-[300px]  flex items-center justify-center bg-no-repeat bg-center bg-cover"
        style={{ backgroundImage: `url(${assets.requirementsbanner})` }}
      >
        <h1 className="text-subPrimaryColor text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold text-center">
          Ask For A Quick Quotation
        </h1>
      </div>
      <PostRequirementSection offerId={offerId} />
    </section>
  );
};

export default RequirementFill;
